import * as routes from '../enums/modules/routes.js'
const { OrdersEnum, BaseRouteEnum, CustomersEnum } = routes
const ComponentShowOverride = 'ComponentShowOverride'
const InstanceLoadIntervalMS = 1000

const _defer = (cb) => setTimeout(cb, 1)

const routesToShowZendesk = [
  OrdersEnum.Orders,
  OrdersEnum.OrdersWithView,
  OrdersEnum.OrdersWithSearch,
  BaseRouteEnum.DashboardV2,
  ComponentShowOverride,
  CustomersEnum.Customers,
  CustomersEnum.EditCustomer,
  CustomersEnum.ShowCustomer,
  CustomersEnum.CreateCustomer,
  BaseRouteEnum.SetupDashboard
]

export const ZendeskWrapper = {
  routesToShowZendesk,
  zendeskInstance: undefined,
  loadInterval: undefined,
  load: async function (routeName) {
    if (!this.zendeskInstance) {
      this.loadInterval = setInterval(() => {
        if (typeof window.zE === 'function' && typeof window.zE.show === 'function') {
          this.zendeskInstance = window.zE
          this.zendeskLoaded(routeName)
        }
      }, InstanceLoadIntervalMS)
      const ZendeskScript = () => import(/* webpackChunkName: "Zendesk", webpackPrefetch: true */ '../../vendor/zendesk')
      await ZendeskScript()
    }
  },
  zendeskLoaded: function (routeName) {
    clearInterval(this.loadInterval)
    this.determineVisibility(routeName)
  },
  determineVisibility: async function (routeName) {
    if (!this.zendeskInstance) await this.load(routeName)
    else if (this.routesToShowZendesk.includes(routeName)) _defer(this.zendeskInstance.show)
    else _defer(this.zendeskInstance.hide)
  },
  hideZendesk: function () {
    if (this.zendeskInstance) {
      _defer(this.zendeskInstance.hide)
    }
  }
}
